<template>
  <div class="product-item product-seat">
    <div class="product-head clearfix">
      <img
        class="f-left"
        :src="productBase.icon"
        alt
      />
      <div class="f-left">
        <p class="title">{{ productBase.title }}</p>
        <slot name="desc"></slot>
      </div>
    </div>
    <div class="contact flex-hb-vc">
      <div class="passenger form">
        <p>{{ passengerData.passenger.fullName }}</p>
      </div>
      <div class="itinerary form">
        <p>{{ passengerData.itinerary.departureName }} - {{ passengerData.itinerary.arrivalName }}</p>
      </div>
      <div class="seat form">
        <p>{{ value?.seatNumber || '未选择' }}</p>
      </div>
      <div class="price form" v-if="value?.isPaySeat">
        <p>{{ value?.currency === 'CNY' ? '￥' : ''}} {{ value?.price || '未选择' }}</p>
      </div>
      <div class="form">
        <a-button
          key="submit"
          type="primary"
          @click="showModal"
        >{{ value?.seatNumber ? '更改座位' : '去选座' }}</a-button>
      </div>
    </div>
    <a-modal
      v-model="visible"
      :title="productBase.title || '预选座值机'"
      width="100%"
      wrapClassName="full-modal"
      :footer="null"
      @cancel="hideModal"
    >
      <seat-container
        :seatData="seatContainer"
        :seatItem="seatItem"
        :passengerData="passengerData"
        :airplaneData="airplaneData"
        :contentData="contentData"
        :ifInternational="ifInternational"
        @cancelSeat="onCancelSeat"
        @sureSeat="onSureSeat"
        @updateSeat="onUpdateSeat"
      >
      </seat-container>
    </a-modal>
  </div>
</template>

<script>
import seatContainer from './seat-container'
import { assignIn, isEqual, get, cloneDeep } from 'lodash'
const { airline } = window.__MICRO_ROOT__

const seatStatusToClassMap = {
  '*': 'icon2-seats-ordinary',
  'A': 'icon2-seats-ordinary',
  '.': 'icon2-seats-select',
  'N': 'icon2-seats-exit',
  '': 'icon2-seats-null'
}

export default {
  data () {
    return {
      airline,
      visible: false,
      airplaneData: {
        airplaneType: '',
        airplaneClass: ''
      },
      contentData: {
        agreements: [],
        tipContent: '1.确认选座并提交订单成功后，该航段选座人信息不可进行修改。同时，预选座成功后在航班起飞前将为您开启网上自动值机服务。当前仅支持自动值机1次，请您确认好所选座位。 <br> 2.客票一经提交退票、改期、升舱等退票改升操作，免费预留座位将被自动取消。'
      },
      seatItem: null,
      originSeatItem: null,
      seatContainer: []
    }
  },
  props: {
    type: {
      type: String,
      required: true
    },
    products: {
      type: Array,
      required: true
    },
    value: [Object, Array],
    current: Object,
    cart: Object,
    productBase: [Object, Array],
    segment: [Object, Array],
    itinerarys: Array,
    ifInternational: {
      type: Boolean,
      default: false
    }
  },
  watch: {
    // NOTE: 更新座位数据状态，兼容婴儿不选座的场景
    current (newValue, oldValue) {
      if (newValue || (newValue.segmentIndex !== oldValue.segmentIndex)) {
        this.getSeatContainer()
        this.updateSeatContainer()
      }
    },
    seatItem (newValue, oldValue) {
      const { current, seatContainer } = this
      if (oldValue && oldValue.row) {
        const { row, col } = oldValue
        const rowData = seatContainer.find(item => { return item[0].row === row })
        const rowIndex = seatContainer.findIndex(item => { return item[0].row === row })
        const colIndex = rowData.findIndex(item => { return item.col === col })
        if (oldValue.selected && oldValue.selected.passengerIndex === current.passengerIndex && oldValue.selected.segmentIndex === current.segmentIndex) {
          this.$set(seatContainer[rowIndex][colIndex], 'selected', '')
          this.$set(seatContainer[rowIndex][colIndex], 'styleclass', oldValue.styleclassOrigin)
        }
      }
      if (newValue && newValue.row) {
        const { row, col } = newValue
        const rowData = seatContainer.find(item => { return item[0].row === row })
        const rowIndex = seatContainer.findIndex(item => { return item[0].row === row })
        const colIndex = rowData.findIndex(item => { return item.col === col })
        this.$set(seatContainer[rowIndex][colIndex], 'selected', current)
        this.$set(seatContainer[rowIndex][colIndex], 'styleclass', 'seat-checked')
      }
    },
    value (newValue, oldValue) {
      const { current, seatContainer } = this
      if (oldValue && oldValue.row) {
        const { row, col } = oldValue
        const rowData = seatContainer.find(item => { return item[0].row === row })
        const rowIndex = seatContainer.findIndex(item => { return item[0].row === row })
        const colIndex = rowData.findIndex(item => { return item.col === col })
        if (oldValue.selected && oldValue.selected.segmentIndex === current.segmentIndex) {
          this.$set(seatContainer[rowIndex][colIndex], 'selected', current)
          this.$set(seatContainer[rowIndex][colIndex], 'styleclass', 'seat-checked-fellow')
        }
      }
      if (newValue && newValue.row) {
        this.seatItem = newValue || null
      }
    }
  },
  computed: {
    passengerData () {
      const { itinerarys, current } = this
      if (!itinerarys) {
        return []
      }
      return {
        // TODO: 临时调整
        itinerary: itinerarys[current.segmentIndex].orgDsts[0],
        passenger: itinerarys[current.segmentIndex].passengers[current.passengerIndex]
      }
    },
    selectedSeat () {
      const { passengerData } = this
      return get(passengerData, 'passenger.select.seat[0]') || {}
    }
  },
  created () {
    this.getSeatContainer()
    this.contentData.agreements = this.seatAgreeMentList
    this.getCmsData()
  },
  methods: {
    async getCmsData () {
      const { ifInternational } = this
      const pageCmsData = (await window.__MICRO_ROOT__?.cms?.getPageData()) ?? {}
      this.contentData.agreements = get(pageCmsData, 'extra-seat-list.list') ?? []
      this.contentData.tipContent = get(pageCmsData, ifInternational ? 'extra-seat-notice.internationalNotice' : 'extra-seat-notice.notice') ?? this.contentData.tipContent
    },
    getSeatContainer () {
      this.seatContainer = []
      const { products } = this
      // 备份数据，避免污染原始数据(important)
      const [seats, arranges] = [cloneDeep(get(products[0], 'services[0].seatMap.seat') || []), get(products[0], 'services[0].seatMap.arrange') || []]
      const extraData = get(products[0], 'services[0].extraData')
      const lastArranges = []
      for (let index = 0; index < arranges.length - 1; index++) {
        const arrange = arranges[index]
        lastArranges.push(arrange[arrange.length - 1])
      }
      // 座位图一维数组 -> 二维数组
      let row = []
      for (let index = 0; index < seats.length; index++) {
        const seat = seats[index]
        // 过滤掉无效的座位数据
        if (!seat.row) continue
        // 座位清空
        seat.styleclass = ''
        // seat.selected = ''
        // 座位名称
        seat.seatNumber = seat.row + seat.col
        // 锁定座位
        if (this.shouldLockSeat(extraData, seat.row)) {
          seat.seatStatus = 'N'
        }
        // 座位类名
        seat.styleclass = seatStatusToClassMap[seat.seatStatus]
        // 收费座位类名
        if (seat.price && ['*', 'A'].includes(seat.seatStatus)) {
          seat.styleclass = 'icon2-seats-not-free'
        }
        // 渲染过道，col === '='
        if (lastArranges.includes(seat.col)) {
          seats.splice(index + 1, 0, {
            col: '=',
            offerItemId: '',
            price: 0,
            row: seat.row,
            seatStatus: 'N',
            serviceId: '',
            styleclass: ''
          })
        }
        seat.styleclassOrigin = cloneDeep(seat.styleclass)
        if (index === 0) {
          row.push(seat)
        } else if (index > 0 && seat.row === seats[index - 1].row) {
          row.push(seat)
          if (index === seats.length - 1) {
            this.seatContainer.push(row)
          }
        } else {
          this.seatContainer.push(row)
          row = []
          row.push(seat)
        }
      }
    },
    updateSeatContainer () {
      const { current, seatContainer, segment } = this
      const { passengers } = segment
      for (let index = 0; index < passengers.length; index++) {
        const selected = get(passengers[index], 'select.seat[0]') || {}
        if (Object.keys(selected).length > 0) {
          const { row, col } = selected
          const rowData = seatContainer.find(item => { return item[0].row === row })
          const rowIndex = seatContainer.findIndex(item => { return item[0].row === row })
          const colIndex = rowData.findIndex(item => { return item.col === col })
          this.$set(seatContainer[rowIndex][colIndex], 'styleclass', current.passengerIndex === index ? 'seat-checked' : 'seat-checked-fellow')
        }
      }
    },
    showModal  () {
      this.visible = true
      this.seatItem = this.value || null
    },
    hideModal () {
      this.visible = false
      this.seatItem = this.value || null
    },
    onUpdateSeat (seatItem, method) {
      this.seatItem = method === 'add' ? seatItem : {}
      this.originSeatItem = seatItem
    },
    onCancelSeat () {
      const { type, passengerData, selectedSeat } = this
      if (selectedSeat) {
        this.$emit('select', type, [], false, {
          offerItemType: 'SEAT',
          detail: {
            offerItemId: selectedSeat.offerItemId,
            productCode: `SEAT-${selectedSeat.seatNumber}`,
            productName: `预选座 (${passengerData.passenger.fullName} ${selectedSeat.seatNumber})`,
            price: selectedSeat.price,
            count: 1
          }
        }, false)
      }
      this.seatItem = null
      this.hideModal()
    },
    onSureSeat () {
      const { type, current, seatItem, originSeatItem, value: oldValue } = this
      const { passenger } = this.passengerData
      const isAdd = !isEqual(originSeatItem ? originSeatItem.offerItemId : {}, oldValue ? oldValue.offerItemId : {})
      if (oldValue) {
        this.$emit('select', type, [], false, {
          offerItemType: 'SEAT',
          detail: {
            offerItemId: oldValue.offerItemId,
            productCode: `SEAT-${oldValue.seatNumber}`,
            productName: `预选座 (${oldValue.passenger.fullName} ${oldValue.seatNumber})`,
            price: oldValue.price,
            count: 1
          }
        }, false)
      }
      if (isAdd) {
        const newValue = { passenger, ...seatItem, ...current }
        const detail = {
          offerItemId: newValue.offerItemId,
          productCode: `SEAT-${newValue.seatNumber}`,
          productName: `预选座 (${newValue.passenger.fullName} ${newValue.seatNumber})`,
          price: newValue.price,
          count: 1
        }
        this.$emit('select', type, [assignIn({}, newValue, detail)], true, {
          offerItemType: 'SEAT',
          detail
        }, false)
      }
      this.hideModal()
    },
    // 根据业务判断是否锁定座位
    shouldLockSeat (extraData = {}, seatRow) {
      const { airline, ifInternational } = this
      const { craftType: craftTypeItem } = extraData.dataLists?.flightSegmentList?.[0] || {}
      // 机型
      const { craftType } = craftTypeItem || {}
      const seatRowNumber = parseInt(seatRow)
      // JD航班，330大类飞机的特殊规则 - 国际航班50排后
      if (airline === 'JD' && ['330', '33A', '33B', '33D', '33G', '33N'].includes(craftType)) {
        if (ifInternational && seatRowNumber >= 50) {
          return true
        }
      }
      return false
    }
  },
  components: {
    seatContainer
  }
}
</script>

<style lang="less">
.product-seat {
  .contact {
    > div {
      width: 25%;
      font-size: 14px;
      text-align: center;
    }
  }
}
.full-modal {
  .ant-modal {
    max-width: 100%;
    top: 0;
    padding-bottom: 0;
    margin: 0;
  }
  .ant-modal-content {
    display: flex;
    flex-direction: column;
    min-height: calc(100vh);
  }
  .ant-modal-body {
    flex: 1;
  }
}
</style>
